import React from 'react';
import PropTypes from 'prop-types';
import Highlight from '../Highlight';

/** @type {import('./index').ProHighlight} */
const ProHighlight = ({ className, type, additionalData = {} }) => {
    const proEnriched = { ...additionalData, isPro: true };

    return <Highlight className={className} type={type} additionalData={proEnriched} />;
};

ProHighlight.propTypes = {
    className: PropTypes.string,
    type: PropTypes.string,
    additionalData: PropTypes.object,
};

export default ProHighlight;
